module.exports = __webpack_public_path__ + "static/media/yardwork.dc0392ec.png";